import { ClusterSegment, DateHistogramSegment, FilterSegment, FilterSegmentItem, GroupBySegment } from './editor/Segment';
import { Metric } from './editor/Metric';
import { ChartPreferences } from './options/VisualOptionsDomain';
import { FormicaTimePickerDate } from '../../components/custom/custom-time-picker/TimePickerDomain';
import { FormicaSelectBoxItem } from '../../components/custom/FormicaSearchSelectBox';
import { ChartType } from '@trlogic/ui-pack';
import { ChartOptions } from 'chart.js';

export interface Chart {
  id: string | undefined;
  name: string | null;
  description: string | null;
  dataSource: string | null;
  dashboardId: string | null;
  type: ChartType | null;
  createdDate: number;
  updatedDate: number;
  visualOptions: Partial<ChartOptions>;
}

export interface ChartResponse {
  id: string;
  name: string;
  type: string;
  favorite: boolean;
  attributes: Record<string, any>; // CHART EDITOR OPTIONS
  result: ChartJsDataModel;
  isStaticChart?: boolean;
}

export interface ChartJsonModel {
  id?: string;
  name: string;
  description: string;
  dataSource: string;
  type: ChartType;
  dashboardId: string;
  createdDate: number;
  updatedDate: number;
  chartEditorOptions: Partial<ChartEditorOptions>;
  visualOptions: Partial<ChartOptions>;
}

export interface ChartEditorOptions {
  transactionVariables: FormicaSelectBoxItem[];
  segmentEditorVisible: boolean;
  metricEditorVisible: boolean;
  globalFilterEditorVisible: boolean;
  breakdownEditorVisible: boolean;
  startDate: FormicaTimePickerDate;
  endDate: FormicaTimePickerDate;
  segmentItem: SegmentItem | null;
  metricItem: MetricItem[];
  activeMetricItem: MetricItem | null;
  globalFilterItem: FilterSegmentItem | null;
  breakdown: SegmentItem | null;
}

export interface AxisItem {
  name: string;
}

export interface SegmentItem extends AxisItem {
  activeTab: SegmentItemTabs;
  colorPalette: string[];
  segments: {
    dateHistogram: DateHistogramSegment | undefined;
    clustering: ClusterSegment | undefined;
    groupBy: GroupBySegment | undefined;
    filter: FilterSegment | undefined;
  };
}

export interface MetricItem extends AxisItem {
  metric: Metric;
}

export enum SegmentItemTabs {
  DATE_HISTOGRAM = 'DATE_HISTOGRAM',
  CLUSTERING = 'CLUSTERING',
  GROUP_BY = 'GROUP_BY',
  FILTER = 'FILTER',
}

export interface ChartJsDataModel {
  labels: string[];
  datasets: ChartJsDatasetModel[];
}

export interface ChartJsDatasetModel {
  label: string;
  data: number[];
  backgroundColor: string | string[];
  borderColor: string;
  borderWidth: number;
}

export interface ColorSettings {
  colorPalette: string[];
  activeColor: string;
}

export enum ChartExecuteType {
  INDICATOR = 'INDICATOR',
  SINGLE = 'SINGLE',
  MULTI = 'MULTI',
  BREAKDOWN = 'BREAKDOWN',
}
